    <template>
        <div class="ele-body">
            <el-card shadow="never" body-style="padding-top: 5px;">
                <!-- 编辑弹窗 -->
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                    <el-form-item label="邀请好友标题:" prop="friends_title">
                        <el-input v-model="editForm.friends_title" placeholder="请输入邀请好友标题" clearable />
                    </el-form-item>

                    <el-form-item label="邀请好友图标:" prop="friends_icon">
                        <ele-uploadimage :limit="1" v-model="editForm.friends_icon"></ele-uploadimage>

                    </el-form-item>
                    <el-form-item label="邀请好友人数:" prop="friends_num">
                        <el-input-number v-model="editForm.friends_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入邀请好友人数" clearable />
                    </el-form-item>
                    <el-form-item label="邀请好友积分:" prop="friends_integral">
                        <el-input-number v-model="editForm.friends_integral" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入邀请好友积分" clearable />
                    </el-form-item>
                    <el-form-item label="好友下单标题:" prop="friends_order_title">
                        <el-input v-model="editForm.friends_order_title" placeholder="请输入好友下单标题" clearable />
                    </el-form-item>

                    <el-form-item label="好友下单图标:" prop="friends_order_icon">
                        <ele-uploadimage :limit="1" v-model="editForm.friends_order_icon"></ele-uploadimage>

                    </el-form-item>
                    <el-form-item label="好友下单次数:" prop="friends_order_num">
                        <el-input-number v-model="editForm.friends_order_num" controls-position="right"
                            :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入好友下单次数"
                            clearable />
                    </el-form-item>
                    <el-form-item label="好友下单积分:" prop="friends_order_integral">
                        <el-input-number v-model="editForm.friends_order_integral" controls-position="right"
                            :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入好友下单积分"
                            clearable />
                    </el-form-item>
                    <el-form-item label="购买商品标题:" prop="buy_title">
                        <el-input v-model="editForm.buy_title" placeholder="请输入购买商品标题" clearable />
                    </el-form-item>

                    <el-form-item label="购买商品图标:" prop="buy_icon">
                        <ele-uploadimage :limit="1" v-model="editForm.buy_icon"></ele-uploadimage>

                    </el-form-item>
                    <el-form-item label="购买商品次数:" prop="buy_num">
                        <el-input-number v-model="editForm.buy_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入购买商品次数" clearable />
                    </el-form-item>
                    <el-form-item label="购买商品积分:" prop="buy_integral">
                        <el-input-number v-model="editForm.buy_integral" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入购买商品积分" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存更改</el-button>
                    </el-form-item>
                </el-form>

            </el-card>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'

        export default {
            name: "SysIntegralTask",
            components: {
                EleUploadimage,
            },
            data() {
                return {
                    table: {
                        url: '/integral/IntegralTask/index',
                        where: {
                            "friends_icon": [],
                            "friends_order_icon": [],
                            "buy_icon": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "friends_icon": [],
                        "friends_order_icon": [],
                        "buy_icon": []
                    }, // 表单数据
                    editFormTemp: {
                        "friends_icon": [],
                        "friends_order_icon": [],
                        "buy_icon": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    editRules: { // 表单验证规则

                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        friends_title: [{
                            required: true,
                            message: '请输入邀请好友标题',
                            trigger: 'blur'
                        }],


                        friends_icon: [{
                            required: true,
                            message: '请上传邀请好友图标',
                            trigger: 'blur'
                        }],


                        friends_num: [{
                            required: true,
                            message: '请输入邀请好友人数',
                            trigger: 'blur'
                        }],


                        friends_integral: [{
                            required: true,
                            message: '请输入邀请好友积分',
                            trigger: 'blur'
                        }],


                        friends_order_title: [{
                            required: true,
                            message: '请输入好友下单标题',
                            trigger: 'blur'
                        }],


                        friends_order_icon: [{
                            required: true,
                            message: '请上传好友下单图标',
                            trigger: 'blur'
                        }],


                        friends_order_num: [{
                            required: true,
                            message: '请输入好友下单次数',
                            trigger: 'blur'
                        }],


                        friends_order_integral: [{
                            required: true,
                            message: '请输入好友下单积分',
                            trigger: 'blur'
                        }],


                        buy_title: [{
                            required: true,
                            message: '请输入购买商品标题',
                            trigger: 'blur'
                        }],


                        buy_icon: [{
                            required: true,
                            message: '请上传购买商品图标',
                            trigger: 'blur'
                        }],


                        buy_num: [{
                            required: true,
                            message: '请输入购买商品次数',
                            trigger: 'blur'
                        }],


                        buy_integral: [{
                            required: true,
                            message: '请输入购买商品积分',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {
                this.edit();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit() {
                    this.$http.get('/integral/IntegralTask/info?id=1').then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/integral/IntegralTask/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的积分任务吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/integral/IntegralTask/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/integral/IntegralTask/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/integral/IntegralTask/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },


            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>